
export default class MemberMeta {
  public currentPage: number
  public totalPages: number
  public counters: any

  constructor (attributes) {
    Object.assign(this, attributes)
  }
}
